export const textMask = {
	mask: /^[a-zA-Zа-яёА-ЯЁ ]+$/,
};
